import { Box, ClassNameMap } from '@mui/material';
import { UpliftThemeProvider } from '../../theme';
import { ContextualNavigationHeader, ContextualNavigationHeaderProps } from './ContextualNavigationHeader';
import { ContextualNavigationProgress } from './ContextualNavigationProgress';
import { useContextualNavigationStyles } from './styles';
import React, { useMemo } from 'react';

export type ContextualNavigationLayoutProps = {
  children: NonNullable<React.ReactNode>;
  fullWidth?: boolean;
  headerProps?: ContextualNavigationHeaderProps;
  progress?: number | React.ReactNode;
  classes?: Partial<ClassNameMap<'root'>>;
};

export const ContextualNavigationLayout: React.FC<ContextualNavigationLayoutProps> = props => {
  const { classes } = useContextualNavigationStyles({
    fullWidth: props.fullWidth ?? false,
    ...props
  }, {
    props: {
      fullWidth: props.fullWidth ?? false,
      ...props
    }
  });

  const progress = useMemo(() => {
    if (!props.progress) {
      return null;
    }

    if (typeof props.progress === 'number') {
      return (
        <ContextualNavigationProgress percent={Number(props.progress)} />
      );
    }

    return (
      <Box flex={0}>
        {props.progress}
      </Box>
    );
  }, [ props.progress ]);

  return (
    <UpliftThemeProvider>
      <Box className={classes.root}>
        <ContextualNavigationHeader {...props.headerProps} fullWidth={props.fullWidth} />
        {progress}
        <Box className={classes.contentRoot}>
          {props.children}
        </Box>
      </Box>
    </UpliftThemeProvider>
  );
};
